import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { showError, showSuccess } from "@/utils/toast";

const NewGame = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const getCsrfToken = (): string | null => {
    const tokenEl = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
    return tokenEl ? tokenEl.content : null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name || !description || !image) {
      showError("Minden mező kitöltése kötelező!");
      return;
    }
    setIsSubmitting(true);

    const csrfToken = getCsrfToken();
    if (!csrfToken) {
      showError("Biztonsági hiba: A CSRF token hiányzik.");
      setIsSubmitting(false);
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("image", image);

    try {
      const response = await fetch("/api/games", {
        method: "POST",
        body: formData,
        headers: { "X-CSRF-Token": csrfToken },
      });
      if (!response.ok) throw new Error("A játék hozzáadása sikertelen volt.");
      showSuccess("Játék sikeresen hozzáadva!");
      // Optionally reset form
      setName("");
      setDescription("");
      setImage(null);
      (e.target as HTMLFormElement).reset();
    } catch (error) {
      showError(error instanceof Error ? error.message : "Ismeretlen hiba történt.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>Új Játék Hozzáadása</CardTitle>
          <CardDescription>Töltsd ki az űrlapot egy új játék felvételéhez.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="name">Játék neve</Label>
              <Input
                id="name"
                placeholder="Pl. Stardew Valley"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="description">Leírás</Label>
              <Textarea
                id="description"
                placeholder="Rövid leírás a játékról"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="image">Kép</Label>
              <Input id="image" type="file" onChange={handleImageChange} accept="image/*" required />
            </div>
            <Button type="submit" className="w-full" disabled={isSubmitting}>
              {isSubmitting ? "Hozzáadás..." : "Játék Hozzáadása"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default NewGame;